
import { camelToKebab, camelToSnake, camelToVue } from './utils.mjs'
import { registerVueComponent, vconsoleAutoNgVueWraper } from './vvuejs.parcel.mjs'
import { declareVConsoleModule } from '/vodalys/vvuejs'

import { debug } from '/vodalys/.jslibs'

const log = debug('vue:declareVconsoleComponent')

/**
 * Déclare un composant vconsole, avec tous les bindings angular, vuejs et vodalysform qui vont bien
 * @param {string} name - le nom du composant  en camel case (monComponentName)
 * @param {(component | function)} component - le composant  vue ou une fonction de la forme () => import('./monComponent.vue) 
 * @param {string} [o] type - un type vform facultatif, au cas ou le type form ne corespond vraiment pas au nom du composant 
 */
export function declareVconsoleComponent(name, component, type) {
    
    type ??= name

    const shortName = name.split('.')[0]
    const vueName = camelToVue(shortName)
    const kebabName = camelToKebab(name)
    const snakeName = camelToSnake(name)
    const vconsoleModuleName = `${camelToSnake(shortName)}.vconsole`

    const ngName = name + 'Ng'
    const ngkebabName = kebabName + '-ng'

    log(`declare ${typeof component === 'function' ? 'async' : 'sync'} component`, name, { name, type, shortName, vueName, kebabName, snakeName, vconsoleModuleName })

    // enregistre le component vue associer au type vfields.inc (kebabName)
    registerVueComponent(type, vueName, component)

    // Déclare et enregistre un component angular qui wrapp le component vue
    const ngModule = declareVConsoleModule(vconsoleModuleName);

    vconsoleAutoNgVueWraper(ngModule, ngName, shortName, component)

    ngModule.run(['vodalys_form_service', function (vodalys_form_service) {
        vodalys_form_service.register({
            weight: 100,
            valid: vodalys_form_service.typeValidator(type),
            directive: ngkebabName
        })
    }])

}
